import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, ComboBox, RadioGroup } from '@reveni-io/reveni-ui'

import DelayDaysInput from '@/common/components/DelayDaysInput/DelayDaysInput'
import ReasonField from '@/common/components/ReasonField/ReasonField'
import { issueExchangeStatusOptions } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/constants'
import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import { triggerModeValues } from '../constants'
import { getTriggerModeOptions, getTriggerOptions } from '../helpers'
import { exchangeTriggerModeOptions } from './constants'
import * as Styles from './styles'

const ForceExchangeOrderTriggerConfig = ({
  config,
  onChangeConfig,
  disabled,
  errors = [],
  availableIssueExchangeStatuses,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasTriggerError = errors.some(e => e.type === errorTypes.actionExchangeTriggerEmpty)
  const hasDelayDaysError = errors.some(e => e.type === errorTypes.actionDelayDaysInvalid)

  const triggerOptions = getTriggerOptions(issueExchangeStatusOptions, t, availableIssueExchangeStatuses)
  const modeOptions = getTriggerModeOptions(exchangeTriggerModeOptions, t)
  const isDelayMode = config.exchange_trigger_mode === triggerModeValues.delayByDays

  const handleChangeTrigger = e => onChangeConfig({ exchange_trigger_status: e.target.value })

  const handleChangeMode = e => {
    const mode = e.target.value

    if (mode === triggerModeValues.delayByDays) {
      onChangeConfig({
        exchange_trigger_mode: mode,
        exchange_trigger_delay_days: config.exchange_trigger_delay_days || '',
        exchange_trigger_delay_reason: config.exchange_trigger_delay_reason || '',
      })
    } else {
      onChangeConfig({
        exchange_trigger_mode: mode,
        exchange_trigger_delay_days: null,
        exchange_trigger_delay_reason: '',
      })
    }
  }

  const handleChangeDelayDays = e => onChangeConfig({ exchange_trigger_delay_days: e.target.value })

  const handleChangeDelayReason = e => onChangeConfig({ exchange_trigger_delay_reason: e.target.value })

  return (
    <Styles.Container>
      <Alert type="warning">{t('Esta acción no aplica a Instant Exchanges.')}</Alert>
      <ComboBox
        label={t('Propiedad')}
        menuItems={triggerOptions}
        handleChange={handleChangeTrigger}
        value={config.exchange_trigger_status || ''}
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={hasTriggerError}
        helperText={hasTriggerError ? t('Este campo es obligatorio') : ' '}
      />
      <RadioGroup
        name="exchange-trigger-mode"
        options={modeOptions}
        value={config.exchange_trigger_mode}
        onChange={handleChangeMode}
      />
      {isDelayMode && (
        <>
          <DelayDaysInput
            value={config.exchange_trigger_delay_days}
            onChange={handleChangeDelayDays}
            disabled={disabled}
            error={hasDelayDaysError}
          />
          <ReasonField
            value={config.exchange_trigger_delay_reason}
            onChange={handleChangeDelayReason}
            disabled={disabled}
            placeholder={t('Explicación del motivo')}
            infoText={t(
              'El motivo se mostrará en la alerta correspondiente para aclarar por qué el pedido de cambio se puso en espera.'
            )}
          />
        </>
      )}
    </Styles.Container>
  )
}

export default ForceExchangeOrderTriggerConfig
